// routes/_app.profile.edit.basic.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () => import('src/clientRoutes/_app.profile.edit.basic')

export const handle = {
  name: 'profile/edit/basic',
  track: { scene: 'profile-edit', section: 'basic' },
}

export default dynamic(getClientModule, { ssr: false })
